import { useSearchParams } from "react-router-dom";

// Create IAM login URL and redirect user for authentication
const SignIn = () => {
  const [params, setParams] = useSearchParams();
  const final_redirect_uri = params.get("final_redirect_uri");

  // IAM_V1
  // const baseUrl = import.meta.env.VITE_PIAM_URL;
  // const response_type = "code";
  // const client_id = import.meta.env.VITE_PIAM_CLIENT_ID;
  // const redirect_uri = import.meta.env.VITE_PIAM_REDIRECT_URL;
  // const scope = "ventures openid";
  // const realm = "/venturessso";

  // const url = new URL(baseUrl);
  // url.searchParams.append("response_type", response_type);
  // url.searchParams.append("client_id", client_id);
  // url.searchParams.append("redirect_uri", redirect_uri);
  // url.searchParams.append("scope", scope);
  // url.searchParams.append("realm", realm);
  // url.searchParams.append("state", final_redirect_uri || "null");

  // IAM_V2
  const prefixUrl = import.meta.env.VITE_IAM_V2_PIAM_PREFIX_URL;
  const baseUrl = import.meta.env.VITE_IAM_V2_PIAM_URL;
  const tenantId = import.meta.env.VITE_IAM_V2_PIAM_TENANT_ID;
  const client_id = import.meta.env.VITE_IAM_V2_PIAM_CLIENT_ID;
  const redirect_uri = import.meta.env.VITE_IAM_V2_PIAM_REDIRECT_URL;
  const scope = import.meta.env.VITE_IAM_V2_PIAM_SCOPE;

  // IAM_V2 - Part_2 (OAuth URL)
  const oauthUrl = new URL(
    `${baseUrl}/${tenantId}/oauth2/v2.0/authorize`
  );

  oauthUrl.searchParams.append("response_type", "code");
  oauthUrl.searchParams.append("client_id", client_id);
  oauthUrl.searchParams.append(
    "scope",
    `${scope} ${client_id}/.default`
  );
  oauthUrl.searchParams.append("redirect_uri", redirect_uri);
  oauthUrl.searchParams.append(
    "state",
    final_redirect_uri || "null"
  );

  // IAM_V2 - Part_1 (Prefix)
  const url = new URL(prefixUrl);

  // IAM_V2 - Combined Endpoint (Part_1 + Part_2)
  url.searchParams.append(
    "goto",
    oauthUrl.toString()
  );

  console.log("params =", Object.fromEntries(params.entries()));
  console.log("OAuth URL =", oauthUrl.href);
  console.log("Final IAM URL =", url.href);

  // Redirect user to IAM login page

  window.location.href = url.href;

  return <></>;
};

export default SignIn;
